/*import Vue from 'vue'*/

import ConstUtils from '@/utils/ConstUtils.js';
import EventUtils from '@/utils/EventUtils.js';
import MapUtils from '@/utils/MapUtils.js';

const state = {
  list: [],
  map: {},
};

const getters = {
    EmployeePreferencesStorage_State: state => state,
};

const actions = {
};

const mutations = {
  SOCKET_ONMESSAGE (state, event)  {
    if (event.status == EventUtils.STATUS.COMPLETE && event.statusCode == EventUtils.CODE.OK) {
      if (event.Payload && event.Payload.EmployeePreferencesMap) {
        var prefs = event.Payload.EmployeePreferencesMap;
        state.map = MapUtils.updateMap(prefs, state.map);
        state.list = Object.values(state.map);
      }
      if (event.Payload && event.Payload.EmployeePreferences) {
        var pref = event.Payload.EmployeePreferences;
        state.map[pref[ConstUtils.FIELDS.ID]] = pref;
        state.list = Object.values(state.map);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};